import ApiService from "../../api.service";
import appConfig from "../../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const FeatureAvailabilityService = {
  async getFeatureAvailability(customerCode) {
    return await ApiService.get(
      `api/FeatureAvailability?customerCode=${encodeURIComponent(customerCode)}`
    );
  },

  async saveFeatureAvailability(customerCode, changes) {
    ApiService.setHeaders();
    return await ApiService.customRequest({
      method: "put",
      url: "api/FeatureAvailability",
      data: { CustomerCode: customerCode, Changes: changes },
    });
  },
};

export default FeatureAvailabilityService;
export { FeatureAvailabilityService };
